"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports._setSelectedId = _setSelectedId;
exports.setSelectedId = setSelectedId;
exports.getRankSchoolDetail = getRankSchoolDetail;
exports.getRankSchoolList = getRankSchoolList;
/**
 * Created by brickspert on 17-5-11.
 */

var GET_RANK_SCHOOL_LIST = "api/rank/school/GET_RANK_SCHOOL_LIST";
var GET_RANK_SCHOOL_LIST_SUCCESS = "api/rank/school/GET_RANK_SCHOOL_LIST_SUCCESS";
var GET_RANK_SCHOOL_LIST_FAIL = "api/rank/school/GET_RANK_SCHOOL_LIST_FAIL";

var GET_RANK_SCHOOL_DETAIL = "api/rank/school/GET_RANK_SCHOOL_DETAIL";
var GET_RANK_SCHOOL_DETAIL_SUCCESS = "api/rank/school/GET_RANK_SCHOOL_DETAIL_SUCCESS";
var GET_RANK_SCHOOL_DETAIL_FAIL = "api/rank/school/GET_RANK_SCHOOL_DETAIL_FAIL";

var SET_SELECTED_ID = "api/rank/school/SET_SELECTED_ID";

var initialState = {
    list: [],
    loading: false,
    selectedId: '',
    detail: {
        subCategoryName: '',
        source: '',
        list: []
    }
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case GET_RANK_SCHOOL_LIST_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                list: action.result.data.data
            });
        case GET_RANK_SCHOOL_DETAIL:
            return _extends({}, state, {
                loading: true
            });
        case GET_RANK_SCHOOL_DETAIL_SUCCESS:
            if (!action.result.data.success) {
                return _extends({}, state, {
                    loading: false
                });
            }
            return _extends({}, state, {
                detail: action.result.data.data,
                loading: false
            });
        case GET_RANK_SCHOOL_DETAIL_FAIL:
            return _extends({}, state, {
                loading: false
            });
        case SET_SELECTED_ID:
            return _extends({}, state, {
                selectedId: action.selectedId
            });
        default:
            return state;
    }
}

function _setSelectedId(id) {
    return {
        type: SET_SELECTED_ID,
        selectedId: id
    };
}
function setSelectedId(id) {
    return function (dispatch) {
        dispatch(_setSelectedId(id));
        dispatch(getRankSchoolDetail(id));
    };
}

function getRankSchoolDetail(id) {
    return {
        types: [GET_RANK_SCHOOL_DETAIL, GET_RANK_SCHOOL_DETAIL_SUCCESS, GET_RANK_SCHOOL_DETAIL_FAIL],
        promise: function () {
            function promise(client) {
                return client.get("/api/rank/school?categoryId=" + id);
            }

            return promise;
        }()
    };
}

function getRankSchoolList() {
    return {
        types: [GET_RANK_SCHOOL_LIST, GET_RANK_SCHOOL_LIST_SUCCESS, GET_RANK_SCHOOL_LIST_FAIL],
        promise: function () {
            function promise(client) {
                return client.get("/api/rank/school/category");
            }

            return promise;
        }(),
        afterSuccess: function () {
            function afterSuccess(dispatch, getState, response) {
                if (response.data.success) {
                    dispatch(setSelectedId(response.data.data[0].id));
                }
            }

            return afterSuccess;
        }()
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/rank/rankSchool.js
// module id = 494
// module chunks = 0